class Config {
  get API_URL() {
    // return "https://backoffice.rwadiwala.com/backoffice/PCEPts/RW2WS/RWAOSWS.asmx/GOOGOLight4Apps";
    return (
      `${process.env.REACT_APP_API_URL}/RW2WS/RWAOSWS.asmx/GOOGOLight4Apps` ||
      "https://backoffice.rwadiwala.com/Test"
    );
  }

  get isSameOrigin() {
    return window.location.href.startsWith(this.API_URL);
  }

  get BASEPATH() {
    return `${process.env.REACT_APP_BASEPATH || ""}`;
  }

  get isDevelopment() {
    return process.env.NODE_ENV === "development";
  }

  PERSIST_STORE = false;
}

const config = new Config();
(window as any)["config"] = config;
export default config;
